module.exports = __webpack_public_path__ + "static/media/904fd42f-f903-4264-a3fe-41b9bd714b92_1.00eb90bcbed7883cbd360415d13cc118.b1d853a7.png";